import { Trans } from '@lingui/react';
import { Alert } from '@startuptools/ui/Alert';
import { Button } from '@startuptools/ui/Button';
import { DialogActions } from '@startuptools/ui/Dialog';
import { Modal } from '@startuptools/ui/Modal';
import { ModalClose } from '@startuptools/ui/ModalClose';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import React from 'react';
import { TransactionGroupDialog } from './TransactionGroupDialog';
import { DialogContent } from '@startuptools/ui/DialogContent';

export const NextGroupDialog = ({ onClose, skipPrompt }: { onClose: () => void; skipPrompt: boolean }) => {
  const [showCreation, setShowCreation] = React.useState(skipPrompt);

  return (
    <Modal open onClose={onClose}>
      <ModalDialog>
        <DialogContent>
          <ModalClose />

          {showCreation ? (
            <React.Suspense>
              <TransactionGroupDialog
                close={goToNextGroup => {
                  if (goToNextGroup) {
                    setShowCreation(false);
                  } else {
                    onClose();
                  }
                }}
              />
            </React.Suspense>
          ) : (
            <>
              <Alert sx={{ mt: 2 }}>
                <Trans id="All shares in this group are are assigned. Do you want to continue with the next case from Bolagsverket?" />
              </Alert>
              <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                  <Trans id="No" />
                </Button>
                <Button
                  onClick={() => {
                    setShowCreation(true);
                  }}
                >
                  <Trans id="Continue" />
                </Button>
              </DialogActions>
            </>
          )}
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};
